document.addEventListener('DOMContentLoaded', function () {
  const quantityInput = document.getElementById('RFQ-Quantity');
  const totalPriceElement = document.getElementById('rfq-total-price');

  if (!quantityInput || !totalPriceElement) return;

  const initialPrice = totalPriceElement.textContent;

  const priceMatch = initialPrice.match(/([^\d]*)([0-9,.]+)([^\d]*)/);
  const currencyPrefix = priceMatch ? priceMatch[1] : '';
  const priceText = priceMatch ? priceMatch[2] : '0';
  const currencySuffix = priceMatch ? priceMatch[3] : '';

  const productPrice = parseFloat(priceText.replace(/,/g, ''));

  function updateTotalPrice() {
    const quantity = parseInt(quantityInput.value, 10);
    const totalPrice = productPrice * quantity;

    let formattedPrice = totalPrice.toFixed(2);
    formattedPrice = formattedPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    totalPriceElement.textContent = currencyPrefix + formattedPrice + currencySuffix;
  }

  updateTotalPrice();

  quantityInput.addEventListener('change', updateTotalPrice);

  const plusButton = document.querySelector('button[name="plus"]');
  const minusButton = document.querySelector('button[name="minus"]');

  if (plusButton) {
    plusButton.addEventListener('click', function () {
      setTimeout(updateTotalPrice, 10);
    });
  }

  if (minusButton) {
    minusButton.addEventListener('click', function () {
      setTimeout(updateTotalPrice, 10);
    });
  }
});

function openRFQModal() {
  const productTitle = document.querySelector('.product__title h1').textContent;

  let variantSku = '';
  let variantTitle = '';
  let quantity = 1;
  let isAvailable = true;

  const variantSelector = document.querySelector('variant-radios, variant-selects');
  if (variantSelector) {
    const selectedOptions = variantSelector.querySelectorAll(
      '.product-form__input input:checked, .product-form__input select'
    );
    if (selectedOptions.length > 0) {
      let optionsArray = [];
      selectedOptions.forEach((option) => {
        if (option.tagName === 'SELECT') {
          optionsArray.push(option.options[option.selectedIndex].text);
        } else {
          optionsArray.push(option.value);
        }
      });
      variantTitle = optionsArray.join(' / ');
    }

    isAvailable = !variantTitle.includes('Unavailable');

    const addToCartButton = document.querySelector('product-form .product-form__submit');
    if (addToCartButton && addToCartButton.hasAttribute('disabled')) {
      isAvailable = false;
    }
  }

  const variantSkuElement = document.getElementById('Sku-{{ section.id }}');
  if (variantSkuElement) {
    variantSku = variantSkuElement.textContent.trim();
  }

  const quantityInput = document.getElementById('Quantity-{{ section.id }}');
  if (quantityInput) {
    quantity = quantityInput.value;
  }

  document.getElementById('modal-product-title').textContent = productTitle;

  const productInfo = `Product: ${productTitle}`;
  document.getElementById('product-info-field').value = productInfo;
  document.getElementById('product-details-field').value = variantTitle;
  document.getElementById('product-sku').value = variantSku;
  document.getElementById('RFQ-Quantity').value = quantity;

  const submitButton = document.querySelector('#rfq-form .contact__button button');
  if (submitButton) {
    if (!isAvailable) {
      submitButton.setAttribute('disabled', 'disabled');
      submitButton.textContent = 'Not Available';

      let unavailableMessage = document.getElementById('unavailable-message');
      if (!unavailableMessage) {
        unavailableMessage = document.createElement('p');
        unavailableMessage.id = 'unavailable-message';
        unavailableMessage.className = 'form__message';
        unavailableMessage.style.color = '#e32c2c';
        unavailableMessage.textContent = 'Sorry, this product variant is not available. Please select another option.';
        submitButton.parentNode.insertBefore(unavailableMessage, submitButton);
      }
    } else {
      submitButton.removeAttribute('disabled');
      submitButton.textContent = 'Send Request';

      const unavailableMessage = document.getElementById('unavailable-message');
      if (unavailableMessage) {
        unavailableMessage.remove();
      }
    }
  }

  document.getElementById('custom-rfq-modal').style.display = 'block';
}

function closeRFQModal() {
  document.getElementById('custom-rfq-modal').style.display = 'none';
}

window.onclick = function (event) {
  const modal = document.getElementById('custom-rfq-modal');
  if (event.target == modal) {
    closeRFQModal();
  }
};
